import React, {useState} from 'react'
import InformationUserContainer from "../../InformationUserContainer"
import {Button, Form, Input, message} from "antd"
import {changePassword} from "../../../../services/api/apiUser"
import parseToken from "../../../../helpers/parseToken"

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 8, span: 16},
};

function ChangePasswordContainer() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const info = parseToken()

    const onReset = () => {
        form.resetFields()
    }

    const onFinish = async (values) => {
        setLoading(true)
        setError('')

        try {
            const response = await changePassword({
                ...values,
                userName: info.sub || 'dong_nguyen'
            })
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            onReset()
            message.success('Đổi mật khẩu thành công')
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    return (
        <div className="ChangePasswordContainer">
            <InformationUserContainer isActive="change-password">
                <div className="PageHeading HasDescription">
                    <h1 className="PageTitle">Đổi mật khẩu</h1>
                    <p className="Description">Mật khẩu mới có hiệu lực từ lần đăng nhập tiếp theo</p>
                </div>
                <div className="content">
                    {
                        !!error && error.length > 0 && <div className="error">
                            {error}
                        </div>
                    }
                    <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
                        <Form.Item
                            label="Old Password"
                            name="oldPass"
                            rules={[{required: true, message: 'Vui lòng nhập mật khẩu cũ'}]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item
                            label="New Password"
                            name="newPass"
                            rules={[{required: true, message: 'Vui lòng nhập mật khẩu mới'}]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item
                            label="Re-New Password"
                            name="retypedPass"
                            dependencies={['password']}
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Vui lòng nhập lại mật khẩu mới!',
                                },
                                ({getFieldValue}) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('newPass') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('Mật khẩu mới không trùng khớp!'));
                                    },
                                }),
                            ]}
                        >
                            <Input.Password/>
                        </Form.Item>
                        <Form.Item {...tailLayout}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                className="ButtonCustom"
                                loading={loading}
                                disabled={loading}
                            >
                                Change password
                            </Button>
                            <Button htmlType="button" onClick={onReset} type="default">
                                Reset
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </InformationUserContainer>
        </div>
    )
}

export default ChangePasswordContainer